import clsx from 'clsx';
import React from 'react';
import { Heading } from 'react-aria-components';
import styles from './Header.module.scss';

type ModalContentHeaderProps = {
  /** The children to render inside the component. */
  children: React.ReactNode;
  /** Optional property for overriding styles. */
  className?: string;
  /** Optional property for overriding styles. */
  style?: React.CSSProperties;
  /** Sets the horizontal alignment of the text. */
  textAlign?: 'start' | 'end' | 'justify' | 'center';
};

/**
 * The dialog header containing a descriptive title of the dialog content.
 */
export const ModalDialogHeader = ({
  children,
  className,
  style,
  textAlign = 'start',
}: ModalContentHeaderProps) => {
  return (
    <Heading
      className={clsx(styles.modalDialogHeader, className)}
      data-text-align={textAlign}
      data-zds
      slot="title"
      style={style}
    >
      {children}
    </Heading>
  );
};
